// Remove Duplicate Lines Tool — dedupe lines of text with options.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const removeDuplicateLinesTool: Tool = {
  id: "remove-duplicate-lines",
  name: () => m.rd_tool_name(),
  description: () => m.rd_tool_description(),
  icon: "🧹",
  basePath: "/remove-duplicate-lines",
  status: "stable",
  tags: ["text", "duplicate", "lines", "developer"],
  pages: [
    {
      name: () => m.rd_nav_main(),
      path: "/remove-duplicate-lines",
      description: () => m.rd_nav_main_desc(),
      icon: "🧹",
    },
  ],
};
